import masterData from '../masterData';

export const findStation = (line, stationSlug) => {
  return line && line.stations.find(stationId => {
    const station = masterData.station.byId[stationId];
    return station && station.slug === stationSlug
  });
};



// WEBPACK FOOTER //
// ./lib/masterUtil/findStation.js